<template>
    <div class="dropfile">
       <textarea class="form-control " :rows="25" placeholder="Drop a  file here."></textarea>
    </div>
</template>

<script>
export default {
    name:'dropfile',
    props:['columndef'],
    data: function(){
        return{
            rawdata:null
        }
    },
    computed:{
        
    },
    mounted:function(){
        var drop = this.$el;
        var self = this;
        function handleDrop(e) {
            e.stopPropagation();
            e.preventDefault();
            var files = e.dataTransfer.files;
            
            var i, f;
            for (i = 0, f = files[i]; i != files.length; ++i) {
                console.log('Drop:' + f.type)
                if (f.type != "")
                    self.$emit('file', {type:f.type, file:f});
                else {
                    var ext = f.name.match(/\.[0-9a-z]+$/i)[0];
                    console.log('Drop ext:' + ext)
                    self.$emit('file', {type:ext, file:f});
                }
            }
        }

        function handleDragover(e) {
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
        }

        if (drop.addEventListener) {
            drop.addEventListener('dragenter', handleDragover, false);
            drop.addEventListener('dragover', handleDragover, false);
            drop.addEventListener('drop', handleDrop, false);
        }
    },
    watch:{
        // coldef:function(newVal){
        //     if(newVal != this.columndef ){
        //         this.$emit('columndef', newVal)
        //     }
        // }
    }
}
</script>

<style>
.dropfile{
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;


}
.dropfile textarea{
    width:100%;
    border: 1px solid transparent;
    border-radius: .25rem;
    background-color: #ced4da;
}
</style>